export default "__VITE_ASSET__BjFfrsW2__"